
import { ref } from "vue";
import zhCn from "element-plus/lib/locale/lang/zh-cn";
import { Options, Vue } from "vue-class-component";
import { compare, dateConversion, getLocalProject } from "@/utils";
import * as echarts from "echarts";
import {
  dispatchDeepMemoryDeviceOptions,
  dispatchDeepMemorySceneOptions,
  dispatchDeepMemoryTrend,
  dispatchDeepMemoryDateOptions,
  dispatchDeepMemorySubSceneOptions,
  dispatchDeepMemoryRecordList,
  dispatchDeepMemoryCircleChart,
  dispatchDeepMemoryData,
  dispatchDeepFind,
  dispatchRecentTaskrecord,
  dispatchDeepMemoryReport,
  dispatchSendMemory,
  dispatchDeepMemoryDataCread,
  dispatchDeepMemoryDataCreadOld,
} from "@/store/performance/actions";

import { store } from "@/store";
import {
  readGetDeepMemorySceneOption,
  readGetDeepMemoryDeviceOption,
  readGetDeepMemoryTrend,
  readGetDeepMemorySubsceneOption,
  readGetDeepMemoryDateOption,
  readGetDeepMemoryRecondList,
  readGetDeepMemoryCircleChart,
  readGetDeepMemoryData,
  readDeepFind,
  readRecentTaskrecord,
  readGetDeepMemoryReport,
  readGetDeepMemoryDataCread,
  readGetDeepMemoryDataCreadOld,
} from "@/store/performance/getters"; //引入仓库接口
import { dispatchGetDeviceSpecs } from "@/store/device/actions";
import { readDeviceSpecs } from "@/store/device/getters";
import { readUserProfile } from "@/store/main/getters";
import { readMyProjects, readProjectScenes } from "@/store/project/getters";
import { dispatchGetProjectScenes } from "@/store/project/actions";
import { ElMessage } from "element-plus";
import { dispatchGetSimpleScripts } from "@/store/task/actions";
import { readSimpleScriptList } from "@/store/task/getters";
import { color } from "html2canvas/dist/types/css/types/color";
import { number, version } from "echarts/core";

export default class ProjectOverview extends Vue {
  public localProject = Number(getLocalProject());
  public taskId = "";
  public dateVersion = "";
  public loading = false;
  public spanArr = [];
  public cellMerge({ row, column, rowIndex, columnIndex }) {
    if (this.localProject == 34) {
      if (columnIndex === 0) {
        const _row = this.spanArr[rowIndex];
        const _col = _row > 0 ? 1 : 0;

        return {
          rowspan: _row,
          colspan: _col,
        };
      }
    }
  }
  public async load(
    row: any,
    treeNode: unknown,
    resolve: (date: any[]) => void
  ) {
    let date = readRecentTaskrecord(store)
      .filter((v) => v.value == this.taskId)[0]
      .label.split(" ");
    let old_date = this.dateVersion.split(" ");
    let version = readGetDeepMemoryReport(store)?.new_version;
    let old_version = readGetDeepMemoryReport(store)?.old_version;
    let scene = readGetDeepMemoryReport(store)?.config.scene_id;
    let device = readGetDeepMemoryReport(store)?.config.device_id;
    let subScene = readGetDeepMemoryReport(store)?.config.sub_scene;
    let subScene_old = readGetDeepMemoryReport(store)?.config.sub_scene_old;
    let old_scene = readGetDeepMemoryReport(store)?.config.scene_id;
    let old_device = readGetDeepMemoryReport(store)?.config.device_id;
    await dispatchDeepMemoryDataCreadOld(store, {
      project: this.localProject,
      type: "obj",
      date: date[2],
      version: version,
      scene: Number(scene),
      device: Number(device),
      inside_scene: subScene,
      depth: row.depth,

      old_date: old_date[0],
      old_version: old_version,
      old_scene: Number(old_scene),
      old_device: Number(old_device),
      old_inside_scene: subScene_old,
      name: row.name,
    });

    await setTimeout(() => {
      resolve(this.deepMemreportDataCreadOld);
    }, 1000);
  }
  public get deepMemreportDataCreadOld() {
    let list = [];

    readGetDeepMemoryDataCreadOld(store)?.func_list?.new?.forEach(
      (v, index) => {
        v.deviation1 =
          v.size -
          readGetDeepMemoryDataCreadOld(store).func_list.old[index].size;
      }
    );
    list = readGetDeepMemoryDataCreadOld(store).func_list?.new;

    return list;
  }
  public get deepMemreportDataCread() {
    let list = [];

    readGetDeepMemoryDataCread(store)?.func_list?.new?.forEach((v, index) => {
      v.deviation1 =
        v.size - readGetDeepMemoryDataCread(store).func_list.old[index].size;
    });
    list = readGetDeepMemoryDataCread(store).func_list?.new;

    return list;
  }
  public async mounted() {
    this.loading = true;
    await dispatchRecentTaskrecord(store, {
      project: this.localProject,
      is_memory: 1,
    });
    this.taskId = readRecentTaskrecord(store)[0].value;
    await dispatchDeepMemoryDateOptions(store, {
      project: this.localProject,
    });
    if (readGetDeepMemoryDateOption(store).length == 1) {
      this.dateVersion = readGetDeepMemoryDateOption(store)[0];
    } else {
      this.dateVersion = readGetDeepMemoryDateOption(store)[1];
    }

    await dispatchDeepMemoryReport(store, {
      project: this.localProject,
      task_record_id: Number(this.taskId),
      version: this.dateVersion,
    });
    let date = readRecentTaskrecord(store)
      .filter((v) => v.value == this.taskId)[0]
      .label.split(" ");
    let old_date = this.dateVersion.split(" ");
    let version = readGetDeepMemoryReport(store)?.new_version;
    let old_version = readGetDeepMemoryReport(store)?.old_version;
    let scene = readGetDeepMemoryReport(store)?.config.scene_id;
    let device = readGetDeepMemoryReport(store)?.config.device_id;
    let subScene = readGetDeepMemoryReport(store)?.config.sub_scene;
    let subScene_old = readGetDeepMemoryReport(store)?.config.sub_scene_old;
    let old_scene = readGetDeepMemoryReport(store)?.config.scene_id;
    let old_device = readGetDeepMemoryReport(store)?.config.device_id;
    await dispatchDeepMemoryDataCread(store, {
      project: this.localProject,
      type: "obj",
      date: date[2],
      version: version,
      scene: Number(scene),
      device: Number(device),
      inside_scene: subScene,
      depth: 0,

      old_date: old_date[0],
      old_version: old_version,
      old_scene: Number(old_scene),
      old_device: Number(old_device),
      old_inside_scene: subScene_old,
      name: "",
    });
    this.resBase64 = [];
    await this.trendList.forEach((v, index) => {
      this.drawTrend(v, index);
    });
    await this.memoryData();
    await this.memoryTable.forEach((v) => {
      this.getSpanArr(v.data);
    });
    await this.memoryTableAll;
    this.loading = false;
  }
  public deviationColor(item: any) {
    if (item) {
      if (item > 0) {
        return "red";
      }
      if (String(item).indexOf("-") != -1) {
        return "#00b050";
      }
    }
  }
  public resBase64: any[] = []; // 趋势图存储
  public save_report(is_auto?: boolean) {
    let upload_data: any;

    upload_data = {
      project: this.localProject,
      file_list: this.resBase64,
      title: this.formMail.title,
      recv: this.formMail.addressee,
      cc: this.formMail.CC_List,
      send: this.formMail.Sender,
      task_record_id: Number(this.taskId),
      version: this.dateVersion,
    };
    dispatchSendMemory(store, upload_data);
    ElMessage({
      //Message 消息提示
      message: "报告发送中...",
      showClose: true,
    });
    this.edit = false;
  }
  public company(item) {
    if (Math.abs(item) < 1024) {
      return item + "B";
    }
    if (Math.abs(item) >= 1024 && Math.abs(item) < 1024 * 1024) {
      return (item / 1024).toFixed(2) + "K";
    }
    if (Math.abs(item) >= 1024 * 1024 && Math.abs(item) < 1024 * 1024 * 1024) {
      return (item / 1024 / 1024).toFixed(2) + "M";
    }
  }
  public sizeCompany(item) {
    if (String(item) != "") {
      if (Number(item) < 1024) {
        return String(item) + "K";
      }
      if (Number(item) > 1024) {
        return (Number(item) / 1024).toFixed(1) + "M";
      }
    } else {
      return "";
    }
  }
  public deviation(item: any) {
    if (item) {
      if (Math.abs(Number(item)) < 1024) {
        if (item > 0) {
          return "(+" + String(item) + "K)";
        } else {
          return "(" + String(item) + "K)";
        }
      }
      if (Math.abs(Number(item)) > 1024) {
        if (item > 0) {
          return "(+" + String((Number(item) / 1024).toFixed(1)) + "M)";
        } else {
          return "(" + String((Number(item) / 1024).toFixed(1)) + "M)";
        }
      }
    } else {
      return "";
    }
  }
  public get details_list() {
    let list: any = [];
    list = [
      { label: "名称", prop: "name" },
      { label: "类型", prop: "type" },
      { label: "size", prop: "size" },
    ];

    return list;
  }
  public edit = false;
  public sendOut() {
    this.edit = !this.edit;
  }
  public async detailChange() {
    this.loading = true;
    await dispatchRecentTaskrecord(store, {
      project: this.localProject,
      is_memory: 1,
    });
    await dispatchDeepMemoryDateOptions(store, {
      project: this.localProject,
    });
    await dispatchDeepMemoryReport(store, {
      project: this.localProject,
      task_record_id: Number(this.taskId),
      version: this.dateVersion,
    });
    let date = readRecentTaskrecord(store)
      .filter((v) => v.value == this.taskId)[0]
      .label.split(" ");
    let old_date = this.dateVersion.split(" ");
    let version = readGetDeepMemoryReport(store)?.new_version;
    let old_version = readGetDeepMemoryReport(store)?.old_version;
    let scene = readGetDeepMemoryReport(store)?.config.scene_id;
    let device = readGetDeepMemoryReport(store)?.config.device_id;
    let subScene = readGetDeepMemoryReport(store)?.config.sub_scene;
    let subScene_old = readGetDeepMemoryReport(store)?.config.sub_scene_old;
    let old_scene = readGetDeepMemoryReport(store)?.config.scene_id;
    let old_device = readGetDeepMemoryReport(store)?.config.device_id;
    await dispatchDeepMemoryDataCread(store, {
      project: this.localProject,
      type: "obj",
      date: date[2],
      version: version,
      scene: Number(scene),
      device: Number(device),
      inside_scene: subScene,
      depth: 0,

      old_date: old_date[0],
      old_version: old_version,
      old_scene: Number(old_scene),
      old_device: Number(old_device),
      old_inside_scene: subScene_old,
      name: "",
    });
    this.resBase64 = [];
    await this.trendList.forEach((v, index) => {
      this.drawTrend(v, index);
    });
    await this.memoryData();
    this.spanArr = [];
    await this.memoryTable.forEach((v) => {
      this.getSpanArr(v.data);
    });
    await this.memoryTableAll;
    this.loading = false;
  }
  public drawTrend(item, i) {
    let ordinates: any[] = [];
    item.trend.scene_list.forEach((v, index) => {
      ordinates.push({
        name: v,
        type: "line",
        data: item.trend.memory[index],
        smooth: true, // 平滑曲线
        symbol: "circle", //拐点设置为实心
        itemStyle: {
          normal: {
            label: {
              // show: this.getFPS_RawData.device_names.length <= 3 ? true : false,
              show: true,
            },
          },
        },
      });
    });
    let performance_line: any = document.getElementById(
      "performance_line" + item.chinese
    );
    echarts.dispose(performance_line);
    let PerformanceLineChart = echarts.init(performance_line);
    let option;
    option = {
      title: {
        left: "center",
        textStyle: {
          fontSize: 16,
          fontWeight: "normal",
        },
      },
      tooltip: {
        trigger: "axis",
      },
      legend: {
        x: "center",
        y: "bottom",
        padding: [0, 0, 10, 0],
        // data: devices.map(
        //   (item) =>
        //     this.getDeviceSpecs.filter(
        //       (device) => device.id === item.device_id
        //     )[0]?.model.name
        // ),
      },
      grid: {
        left: "4%",
        top: "10%",
        bottom: "20%",
        right: "4%",
        containLabel: true,
      },

      animation: false,
      series: ordinates,
      yAxis: {
        type: "value",
        axisLabel: {
          formatter: "{value}MB",
        },
      },
      xAxis: {
        type: "category",
        data: item.trend.date_list,
      },
    };
    PerformanceLineChart.setOption(option);
    var res_base64 = PerformanceLineChart.getDataURL({
      excludeComponents: ["toolbox"],
    }); //拿到base64 地址，就好下载了。
    let res: any = {};
    res.file_base64 = res_base64;
    (res.chinese = item.chinese), (res.device_name = item.device_name);
    res.filename = "memoryReport" + i + ".png";
    this.resBase64.push(res);
  }
  public get RecentTaskrecord() {
    return readRecentTaskrecord(store);
  }
  public get dateOptions() {
    return readGetDeepMemoryDateOption(store);
  }
  public get memory_risk_list() {
    return readGetDeepMemoryReport(store).memory_risk_list;
  }
  public newVersion = "";
  public oldVersion = "";
  public memoryData() {
    (this.newVersion = readGetDeepMemoryReport(store).new_version),
      (this.oldVersion = readGetDeepMemoryReport(store).old_version);
  }
  public getNum(item1, item2, type) {
    if (item1 == "" || item2 == null) {
      return "--";
    }

    if (type === "risk") {
      if (item1 > item2) {
        return item1 - item2 + "↑";
      } else if (item1 < item2) {
        return item2 - item1 + "↓";
      }
      if (item1 === item2) {
        return "--";
      }
    } else if (type == "moudle") {
      if (item1 > item2) {
        return (item1 - item2).toFixed(2) + "↑";
      } else if (item1 < item2) {
        return (item2 - item1).toFixed(2) + "↓";
      }
      if (item1 === item2) {
        return "--";
      }
    }
  }
  public com_num_color(newItem, oldItem) {
    // if (item.indexOf("↑") != -1) {
    //   return "red";
    // } else if (item.indexOf("↓") != -1) {
    //   return "#00b050";
    // } else {
    //   return "#212529";
    // }
    if (newItem < oldItem) {
      return "#00b050";
    }
    if (oldItem == null) {
      return "#212529";
    } else {
      if (
        readGetDeepMemoryReport(store)?.memory_settings.risk_rule.difference !=
        ""
      ) {
        if (
          newItem - oldItem >
          Number(
            readGetDeepMemoryReport(store)?.memory_settings.risk_rule.difference
          )
        ) {
          return "red";
        }
      } else {
        return "#212529";
      }
    }
  }
  public getRisk(newValue, oldValue, list) {
    let listAll = [];

    list.forEach((v, index) => {
      if (typeof oldValue[index] == "number") {
        if (
          (newValue[index] - oldValue[index]) / oldValue[index] >
          Number(
            readGetDeepMemoryReport(store)?.memory_settings.risk_rule.percentage
          )
        ) {
          listAll.push(true);
        }
        if (
          newValue[index] - oldValue[index] >
          Number(
            readGetDeepMemoryReport(store)?.memory_settings.risk_rule.difference
          )
        ) {
          listAll.push(true);
        }
      }
    });
    if (listAll.some((v) => v == true)) {
      return "高风险";
    } else {
      return "低风险";
    }
  }
  public pos = 0;
  public getSpanArr(data) {
    for (var i = 0; i < data.length; i++) {
      if (i === 0) {
        this.spanArr.push(1);
        this.pos = 0;
      } else {
        // 判断当前元素与上一个元素是否相同
        if (data[i].name === data[i - 1].name) {
          this.spanArr[this.pos] += 1;
          this.spanArr.push(0);
        } else {
          this.spanArr.push(1);
          this.pos = i;
        }
      }
    }
  }
  public get_risk_color(item) {
    if (item === "高风险") {
      return "red";
    } else {
      return "rgb(0, 176, 80)";
    }
  }
  public tdr_risk(item, tdr) {
    let tdrLevel = tdr.level;
    let params = tdr.type;
    let type = "";
    let riskList = readGetDeepMemoryReport(store)?.memory_settings;
    if (params == 0) {
      type = "Android";
    } else {
      type = "iOS";
    }
    if (riskList.tdr_risk_rule[type]["level_" + tdrLevel] == "") {
      return "#606266";
    }
    if (item > riskList.tdr_risk_rule[type]["level_" + tdrLevel]) {
      return "red";
    } else {
      return "#606266";
    }
  }
  public leftAllTable = [];
  public get memoryTableAll() {
    this.leftAllTable = readGetDeepMemoryReport(store).stack?.new;
    return this.leftAllTable;
  }
  public get memoryTableData() {
    return readGetDeepMemoryReport(store);
  }
  public get riskTable() {
    let list = [];
    readGetDeepMemoryReport(store)?.memory_risk_list?.forEach((v, index) => {
      list.push({
        scene: v.scene,
        data: [],
        deviceList: v.device_list,
        deviceLevel: v.device_item,
      });
      for (let i in v.sub_scene) {
        list[index].data.push({
          name: i,
          data: v.sub_scene[i],
        });
      }
    });

    return list;
  }
  public formMail = {
    title: "", //标题
    Sender: "gamerobot@tencent.com", //发件人
    addressee: "", //收件人
    CC_List: "", //抄送人
  };
  public get memoryTable() {
    let list = [];
    readGetDeepMemoryReport(store)?.memory_list?.forEach((v, index) => {
      list.push({
        scene: v.device_name + v.chinese,
        data: [],
        deviceList: v.sub_scenes,
        deviceLevel: v.device_item,
      });
      // for (let i in v.data) {
      //   list[index].data.push({
      //     name: i,
      //     label: v.data[i].label,
      //     data: v.data[i].data,
      //   });
      // }
      v.data.forEach((item, i) => {
        list[index].data.push({
          name: item[0].classification,
          label: item[0].type,
          data: [],
        });
        v.sub_scenes.forEach((h, k) => {
          list[index].data[i].data.push({
            new: item[k].new,
            old: item[k].old,
          });
        });
      });
    });

    return list;
  }
  public get get_is_super() {
    let judge = true;
    let MyProject = readMyProjects(store).filter(
      (item: any) => item.project.id == this.localProject
    )[0]?.is_project_admin;
    if (readUserProfile(store)?.is_super) {
      judge = false;
    } else if (MyProject) {
      judge = false;
    } else {
      judge = true;
    }
    return judge;
  }
  public get trendList() {
    return readGetDeepMemoryReport(store)?.trend_list;
  }
}
